"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.lightenDarkenColor = void 0;
const color_1 = __importDefault(require("color"));
function lightenDarkenColor(hex, amt) {
    const colorHex = color_1.default(hex);
    const color = amt > 0 ? colorHex.lighten(Math.abs(amt)) : colorHex.darken(Math.abs(amt));
    return color.hex();
}
exports.lightenDarkenColor = lightenDarkenColor;
//# sourceMappingURL=index.js.map